import {
  GenericForm,
  GenericFormLogicalField,
  genericBeforeValidate_removeDefaultKeyedError,
  ValidationEvent,
  genericValidate_textField,
  GenericTextFieldValidationOptions,
} from "../../../hooks";

interface AddressLineFormLogicProps<
  Form extends GenericForm,
  App extends unknown
> {
  required?: boolean;

  guard?: GenericTextFieldValidationOptions<Form, App>["guard"];
}

const maxManualAddressLineLength = 32;

export const addressLineFormLogic = <
  Form extends GenericForm,
  App extends unknown
>(
  props: AddressLineFormLogicProps<Form, App> = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: genericValidate_textField({
    required: props.required,
    maxLength: maxManualAddressLineLength,
    guard: props.guard,
  }),
});
